function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React from "react";
import { register } from "@diana-ui/registry";
import * as ErrorTextInputStyles from "./ErrorTextInput.style";

var ErrorTextInput = _ref => {
  var { className, error, hint, ref } = _ref,
    props = _objectWithoutProperties(_ref, ["className", "error", "hint", "ref"]);

  return /*#__PURE__*/ React.createElement(
    ErrorTextInputStyles.ErrorTextInputWrapper,
    {
      className: className
    },
    /*#__PURE__*/ React.createElement(
      ErrorTextInputStyles.StyledBaseTextInput,
      _extends({}, props, {
        hasError: typeof error === "boolean" ? error : error !== null && error !== undefined
      })
    ),
    /*#__PURE__*/ React.createElement(
      ErrorTextInputStyles.HelperLabel,
      null,
      error && typeof error === "string"
        ? /*#__PURE__*/ React.createElement(
            ErrorTextInputStyles.TypedLabel,
            {
              error: true
            },
            error
          )
        : hint
        ? /*#__PURE__*/ React.createElement(
            ErrorTextInputStyles.TypedLabel,
            {
              hint: true
            },
            hint
          )
        : /*#__PURE__*/ React.createElement(ErrorTextInputStyles.TypedLabel, null, "\xA0")
    )
  );
};

ErrorTextInput.displayName = "ErrorTextInput";
register(ErrorTextInput);
export { ErrorTextInputStyles };
export default ErrorTextInput;
